// extracted by mini-css-extract-plugin
module.exports = {"container":"src-widgets-EventConnectedInfo-components-IssueStatus-styles__container--pRxPQ","status":"src-widgets-EventConnectedInfo-components-IssueStatus-styles__status--2l_0e"};